import React, { Component } from 'react'

import Button from '../../components/Button/'
import Error from '../../components/Error/'
import { Cross } from '../Icons'
import { Container, Popup, CloseButton, ButtonContainer, Title, Header, Inner } from './styles'
import { white, almostblack, black, lightgray, red } from '../../styles/colors'

class RepeatOrderPopup extends Component {
  handleSubmit(e) {
    e.preventDefault()
    this.props.repeatOrder({ variables: { data: { id: this.props.id } } })
  }

  handleChange(e) {
    this.setState({ message: e.target.value })
  }

  render() {
    const { title, confirm, deny, error } = this.props
    if (error) {
      return <Error message={`Fout opgetreden bij het herhalen van uw bestelling met ID: ${this.props.id}`} />
    }

    return (
      <Container>
        <Popup>
          <Inner>
            <Header>
              <Title>{title}</Title>

              <CloseButton onClick={this.props.closePopup}>
                <Cross size="xlarge" />
              </CloseButton>
            </Header>
            <ButtonContainer>
              <Button
                background={red}
                color={white}
                border={red}
                radius="true"
                hover={almostblack}
                hoverColor={white}
                onSubmit={this.handleSubmit.bind(this)}
              >
                {confirm}
              </Button>

              <Button
                background={white}
                color={black}
                border={lightgray}
                radius="true"
                hover={almostblack}
                hoverColor={white}
                onSubmit={this.props.closePopup}
              >
                {deny}
              </Button>
            </ButtonContainer>
          </Inner>
        </Popup>
      </Container>
    )
  }
}

export default RepeatOrderPopup



// WEBPACK FOOTER //
// ./src/components/SubmitOrderPopup/RepeatOrderPopup.js